videojs.addLanguage('fr', {
  "title_share": "Réseaux sociaux",
  "subtitle": "Partager sur :"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_share/dist/lang/fr.js
// module id = 542
// module chunks = 39